import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { addStarRating, fetchStarRating, updateStarRating } from '../actions/starRatingAction';
import CustomToaster from './CustomToaster';
import  '../styles/StarRating.css';

const StarRating = () => {
  const [chatId, setChatId] = useState(null);
  const [datasetId, setDatasetId] = useState(null);
  const [rating, setRating] = useState(0);
  const [id, setId] = useState(null); 
  const [toasterVisible, setToasterVisible] = useState(false);
  const [toasterMessage, setToasterMessage] = useState("");
  const [toasterAppearance, setToasterAppearance] = useState("success"); 
  const dispatch = useDispatch();

  const showToaster = (message, appearance) => {
    setToasterVisible(true);
    setToasterMessage(message);
    setToasterAppearance(appearance);
  };

  const closeToaster = () => {
    setToasterVisible(false);
  };


 useEffect(() => {
  const queryParams = new URLSearchParams(location.search);
  const newChatId = queryParams.get("cid");
  const newDatasetId = queryParams.get("c");
  
  if (newChatId !== chatId) setChatId(newChatId); 
  if (newDatasetId !== datasetId) setDatasetId(newDatasetId);  
}, [location.search]); 

 
  
  useEffect(() => {
    if (chatId) {
      const fetchRating = async () => {
        try {
          const response = await dispatch(fetchStarRating(chatId));
            if (response && response.data && response.data.length > 0) {
            setRating(response.data[0].rating);
            setId(response.data[0]._id);
            console.log("Previously rated:", response.data[0].rating);
            } else { 
            setRating(0);
            console.log("Not rated");
          }
        } catch (error) {
          console.error('Error fetching rating:', error);
        }
      };
      fetchRating();
    }
  }, [chatId, dispatch]);

  const handleRating = async (star) => {
    if (chatId && datasetId && rating==0 ) { 
      const payload = {
        chatId,
        rating: star,
        datasetId,
        createdUTC: new Date().toISOString(),
        updatedAt: new Date().toISOString(),
      };

      try {
        const response =await dispatch(addStarRating(payload)); 
        setRating(star);
        setId(response._id);
        setToasterMessage('Rating submitted successfully');
        showToaster('Rating submitted successfully', 'success');
        console.log('Rating submitted:', star);
      } catch (error) {
        setToasterMessage('Rating is not submitted');
        showToaster('Rating is not submitted', 'error');
        console.error('Error submitting rating:', error);
      }
    } else if (rating > 0 && chatId && datasetId) {
      const payload = {
        chatId,
        rating: star,
        datasetId,
        createdUTC: new Date().toISOString(),
        updatedAt: new Date().toISOString(),
        _id: id,
      };
      try {
        await dispatch(updateStarRating(payload)); 
        setRating(star);
        setToasterMessage('Rating updated successfully'); 
        showToaster('Rating updated successfully', 'success');
        console.log('Rating updated:', star);
      } catch (error) {
        setToasterMessage('Rating is not updated');
        showToaster('Rating is not updated', 'error');
        console.error('Error updating rating:', error);
      }
    }
  };

  return (
    <>
    {toasterVisible && (
        <CustomToaster
          message={toasterMessage}
          duration={3000}
          onClose={closeToaster}
          position="right-top"
          appearance={toasterAppearance}
        />
      )}
    
        <div className="star-rating">
          <p className="experience-text">How was your experience?</p>
          {[1, 2, 3, 4, 5].map((star) => (
            <span
              key={star}
              className={`star ${rating >= star ? 'selected' : ''}`}
              onClick={() => handleRating(star)}
            >
              ★
            </span>
          ))}
        </div>
      
      </>
  );
};

export default StarRating;



